import React from 'react'
import { string, arrayOf, object, shape } from 'prop-types'

// Components
import Article from './Article.jsx'

// Constants
const MAX_ARTICLES = 8

const Editorial = props => {
  const { domainSettings: { scheme, domain } } = props
  const urlBase = `${scheme}://${domain}`
  const articles = props.relatedPages.slice(-MAX_ARTICLES)
  return (
    <div className='container-fluid'>
      <div className='row'>
        { articles.map((article, index) => <Article key={article.title} article={article} urlBase={urlBase} />) }
      </div>
    </div>
  )
}

Editorial.propTypes = {
  domainSettings: object.isRequired,
  relatedPages: arrayOf(shape({
    title: string.isRequired,
    description: string.isRequired,
    link: string.isRequired,
    image: string.isRequired
  })).isRequired
}

export default Editorial
